<template>
  <div
    :class="{ drag_enter: isDragEnter }"
    class="relative min-h-[calc(100vh-81px)]"
    @dragenter="isDragEnter = true"
    @dragover.prevent="isDragEnter = true"
  >
    <contact-us-form
      :show="showContactSales"
      @close="closeContactSales"
      :formId="contactSalesFormId"
    />
    <div
      v-if="isDragEnter"
      class="drag_hover flex justify-center items-end text-5xl text-primary-base h-[calc(100vh-81px)]"
      @dragleave="isDragEnter = false"
      @drop="dropFile($event)"
    >
      <div
        class="pointer-events-none flex flex-col items-center fixed bottom-2"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          version="1.1"
          width="56"
          height="56"
          viewBox="0 0 24 24"
          class="stroke-current text-white fill-[#2b5de5]"
        >
          <path
            d="M19.35,10.04C18.67,6.59 15.64,4 12,4C9.11,4 6.6,5.64 5.35,8.04C2.34,8.36 0,10.91 0,14A6,6 0 0,0 6,20H19A5,5 0 0,0 24,15C24,12.36 21.95,10.22 19.35,10.04M19,18H6A4,4 0 0,1 2,14C2,11.95 3.53,10.24 5.56,10.03L6.63,9.92L7.13,8.97C8.08,7.14 9.94,6 12,6C14.62,6 16.88,7.86 17.39,10.43L17.69,11.93L19.22,12.04C20.78,12.14 22,13.45 22,15A3,3 0 0,1 19,18M8,13H10.55V16H13.45V13H16L12,9L8,13Z"
          />
        </svg>
        <div class="px-7 py-7 mb-7 bg-primary-base rounded-[40px]">
          <p class="italic font-semibold text-xs text-white">
            {{ $t("app.list.drop_file") }}
          </p>
        </div>
      </div>
    </div>
    <div class="storage-wrapper">
      <div class="storage-title">{{ $t("app.list.your_storage") }}</div>
      <div class="storage-bar" :style="{ background: gradientColor }">
        <div class="storage-bar-text">{{ percentageGB }}%</div>
      </div>
      <div class="storage-description">
        <div class="flex items-center gap-[10px]">
          <p class="storage-description-text">
            {{ totalSizeGB }} GB {{ $t("app.list.used_of") }} 3 GB
            {{ $t("app.list.used") }}
          </p>
          <!-- <Button class="line-button default buy-storage h-4"
            >Buy Storage</Button
          > -->
        </div>
      </div>
    </div>
    <div class="apps__body max-w-[1200px]">
      <div class="apps__filter_panel">
        <div class="flex flex-row gap-3">
          <Select
            class="!w-[160px]"
            v-model="extensionFilter"
            :default-text="$t('filter.extension.title')"
            :options="extensionOptions"
            multiple
          >
          </Select>
          <Select
            v-if="labelOptions.length !== 0"
            class="!w-[160px]"
            v-model="labelFilter"
            :default-text="$t('filter.label.title')"
            :options="labelOptions"
            multiple
          >
          </Select>
          <div
            v-if="clearFilterControl"
            class="clear-filters"
            @click="clearFilter"
          >
            <span
              class="text-primary-base text-xs font-extrabold dark:text-secondary-300"
            >
              {{ $t("filter.general.clear") }}
            </span>
          </div>
        </div>
        <Button class="primary h-[42px] px-6" @click="clickFileUpload">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="16"
            viewBox="0 0 15 16"
            fill="none"
          >
            <path
              d="M5.65617 11.073V7.3855L4.427 8.61466"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5.65625 7.3855L6.88542 8.61466"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M13.6459 6.77091V9.84383C13.6459 12.9167 12.4167 14.1459 9.34383 14.1459H5.65633C2.58341 14.1459 1.35425 12.9167 1.35425 9.84383V6.15633C1.35425 3.08341 2.58341 1.85425 5.65633 1.85425H8.72925"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M13.6459 6.77091H11.1876C9.34383 6.77091 8.72925 6.15633 8.72925 4.31258V1.85425L13.6459 6.77091Z"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="text-[11px] font-medium ml-1">
            {{ $t("button.app.upload") }}
          </span>
        </Button>
      </div>
      <div class="flex flex-row justify-between items-center">
        <p class="font-bold text-xs dark:text-primary-white">
          {{ $t("app.list.title") }}
          <span class="text-secondary-300 font-medium text-xs">
            {{ appNumber }}</span
          >
        </p>

        <div class="app__filter">
          <div
            @click="toggleView(false)"
            :class="{
              'app__filter__item--active': isGridView,
            }"
            class="app__filter__item w-12 rounded-l-lg"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 19 19"
              fill="none"
            >
              <path
                d="M17.0488 6.82008V3.79008C17.0488 2.59758 16.5688 2.11758 15.3763 2.11758H12.3463C11.1538 2.11758 10.6738 2.59758 10.6738 3.79008V6.82008C10.6738 8.01258 11.1538 8.49258 12.3463 8.49258H15.3763C16.5688 8.49258 17.0488 8.01258 17.0488 6.82008Z"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.42383 7.00758V3.60258C8.42383 2.54508 7.94383 2.11758 6.75133 2.11758H3.72133C2.52883 2.11758 2.04883 2.54508 2.04883 3.60258V7.00008C2.04883 8.06508 2.52883 8.48508 3.72133 8.48508H6.75133C7.94383 8.49258 8.42383 8.06508 8.42383 7.00758Z"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M17.0488 15.4451V12.4151C17.0488 11.2226 16.5688 10.7426 15.3763 10.7426H12.3463C11.1538 10.7426 10.6738 11.2226 10.6738 12.4151V15.4451C10.6738 16.6376 11.1538 17.1176 12.3463 17.1176H15.3763C16.5688 17.1176 17.0488 16.6376 17.0488 15.4451Z"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.42383 15.4451V12.4151C8.42383 11.2226 7.94383 10.7426 6.75133 10.7426H3.72133C2.52883 10.7426 2.04883 11.2226 2.04883 12.4151V15.4451C2.04883 16.6376 2.52883 17.1176 3.72133 17.1176H6.75133C7.94383 17.1176 8.42383 16.6376 8.42383 15.4451Z"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div
            @click="toggleView(true)"
            :class="{
              'app__filter__item--active': !isGridView,
            }"
            class="app__filter__item w-12 rounded-r-lg"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 19 19"
              fill="none"
            >
              <path
                d="M17.1992 6.82008V3.79008C17.1992 2.59758 16.7192 2.11758 15.5267 2.11758H12.4967C11.3042 2.11758 10.8242 2.59758 10.8242 3.79008V6.82008C10.8242 8.01258 11.3042 8.49258 12.4967 8.49258H15.5267C16.7192 8.49258 17.1992 8.01258 17.1992 6.82008Z"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.57422 7.00758V3.60258C8.57422 2.54508 8.09422 2.11758 6.90172 2.11758H3.87172C2.67922 2.11758 2.19922 2.54508 2.19922 3.60258V7.00008C2.19922 8.06508 2.67922 8.48508 3.87172 8.48508H6.90172C8.09422 8.49258 8.57422 8.06508 8.57422 7.00758Z"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.57422 15.4451V12.4151C8.57422 11.2226 8.09422 10.7426 6.90172 10.7426H3.87172C2.67922 10.7426 2.19922 11.2226 2.19922 12.4151V15.4451C2.19922 16.6376 2.67922 17.1176 3.87172 17.1176H6.90172C8.09422 17.1176 8.57422 16.6376 8.57422 15.4451Z"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.9492 12.2426H16.4492"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M11.9492 15.2426H16.4492"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </div>
      </div>

      <input
        accept=".ipa,.apk,.aab"
        @change="getFile"
        ref="file"
        type="file"
        class="hidden"
        :key="i"
      />
      <div v-if="loading" class="loading">
        <div class="lds-ripple">
          <div></div>
          <div></div>
        </div>
      </div>
      <div v-else-if="apps.length === 0" class="no-apps-wrapper">
        <div v-if="appFilters.length !== 0" class="no-apps">
          <p v-if="isSearched" class="text-center">
            <b class="!font-bold">{{ $t("input.no_result.sorry") }}</b>
            {{ $t("input.no_result.subtitle") }}<br />
            {{ $t("input.no_result.app") }}
          </p>
          <p v-else>
            <b class="!font-bold">{{ $t("filter.no_result.sorry") }}</b>
            {{ $t("filter.no_result.title") }}
          </p>
        </div>
        <div
          class="popup__content popup__content--empty"
          @click="clickFileUpload"
        >
          <img
            v-if="theme"
            src="@/assets/images/no-files-dark.svg"
            alt="no file"
            class="h-[184px]"
          />
          <img
            v-else
            src="@/assets/images/no-files.svg"
            alt="no file"
            class="h-[184px]"
          />

          <div class="svg-wrapper">
            <img
              v-if="theme"
              src="@/assets/images/app-item-upload-dark.svg"
              alt="app-item upload"
              class="h-[32px] w-[32px]"
            />
            <img
              v-else
              src="@/assets/images/app-item-upload.svg"
              alt="app-item upload"
              class="h-[32px] w-[32px]"
            />
          </div>
          <div class="flex flex-col items-center">
            <span class="text-sm text-secondary-base dark:text-greyscale-500">
              {{ $t("app.list.empty") }}
            </span>
            <span class="text-sm text-primary-400">
              {{ $t("app.list.supported") }}
            </span>
          </div>
        </div>
      </div>
      <div v-else class="overflow-x-auto">
        <div
          :class="{
            applications__content: !isListViewApps,
            'applications__content--list': isListViewApps,
          }"
        >
          <div
            v-if="isListViewApps && apps.length"
            class="flex justify-around mb-5 min-w-[1100px]"
          >
            <div
              @click="sortList('extension')"
              class="app-item__list__items cursor-pointer translate-x-[-15px]"
            >
              <span class="app-item__list__items__text">
                {{ $t("app.list.extension") }}
              </span>
              <SortingArrow :sortingTitles="sortingTitles.extension" />
            </div>
            <div
              @click="sortList('title')"
              class="app-item__list__items cursor-pointer translate-x-[-50px]"
            >
              <span class="app-item__list__items__text">
                {{ $t("app.spec.name") }}
              </span>
              <SortingArrow :sortingTitles="sortingTitles.title" />
            </div>
            <div
              @click="sortList('size')"
              class="app-item__list__items cursor-pointer translate-x-[-31px]"
            >
              <span class="app-item__list__items__text">
                {{ $t("app.spec.size") }}
              </span>
              <SortingArrow :sortingTitles="sortingTitles.size" />
            </div>
            <div class="app-item__list__items translate-x-[-37px]">
              <span class="app-item__list__items__text">
                {{ $t("app.spec.uploadedby") }}
              </span>
            </div>
            <div
              @click="sortList('label')"
              class="app-item__list__items cursor-pointer translate-x-[-52px]"
            >
              <span class="app-item__list__items__text">
                {{ $t("app.list.label") }}
              </span>
              <SortingArrow :sortingTitles="sortingTitles.label" />
            </div>
            <div
              @click="sortList('createdAt')"
              class="app-item__list__items cursor-pointer translate-x-[-40px]"
            >
              <span class="app-item__list__items__text">
                {{ $t("app.spec.uploadedat") }}
              </span>
              <SortingArrow :sortingTitles="sortingTitles.createdAt" />
            </div>
          </div>
          <ApplicationItem
            v-for="app in appsToShow"
            :key="app.id"
            :app="app"
            @remove-item="removeItem"
            @create-label="createLabel"
            @update-label="updateLabelById"
            @delete-label="deleteLabelById"
            @change-app-label="changeApplicationLabelById"
            @rename-app="renameApplicationById"
            :isShow="isListViewApps"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";
import { APP_FILTERS } from "@/constants";
import ApplicationItem from "@/components/ApplicationItem";
import Select from "@/components/Select";
import Button from "@/components/Button";
import SortingArrow from "@/components/SortingArrow";
import { FORM_ID_LIST } from "@/constants";
const ContactUsForm = () => import("@/components/ContactUsForm");

export default {
  name: "Applications",
  components: {
    ApplicationItem,
    Select,
    Button,
    SortingArrow,
    ContactUsForm,
  },
  data() {
    return {
      apps: [],
      appFilters: [],
      isGridView: true,
      selectedFileExtension: "",
      isResignable: false,
      selectedFile: null,
      loading: false,
      loadingInstall: false,
      i: 0,
      uploadPercentage: 0,
      isDragEnter: false,
      extensionFilter: [],
      labelFilter: [],
      labelOptions: [],
      EXTENSION_ENUM: {
        0: "ipa",
        1: "apk",
        2: "aab",
      },
      isListViewApps: false,
      sortingTitles: {
        title: "default",
        createdAt: "default",
        extension: "default",
        label: "default",
        size: "default",
      },
      sortedApps: [],
      sortAsc: false,
      q: "",
      totalSize: 0,
      sizeControl: 0,
      formIdList: FORM_ID_LIST,
      showContactSales: false,
      contactSalesFormId: "",
      storageLimit: "",
    };
  },
  watch: {
    loadingState: {
      handler(val) {
        this.uploadPercentage = parseInt((100 * val.loaded) / val.total, 0);
      },
    },
    getLabels: {
      handler(value) {
        this.labelOptions = value.map((item) => ({
          value: item.title,
          text: item.title,
          html: `<div class='label-ball' style='background-color: ${item.color};'></div>`,
        }));
      },
    },
    extensionFilter: {
      handler(value) {
        this.removeFilter("appExtension");
        if (value.length) {
          this.filterExtension();
        }
      },
    },
    labelFilter: {
      handler(value) {
        this.removeFilter("appLabel");
        if (value.length) {
          this.filterLabel();
        }
      },
    },
    appFilters: {
      handler(appFilters) {
        sessionStorage.setItem("appFilters", JSON.stringify(appFilters));
        this.applyFilters(appFilters);
      },
    },
    applications: {
      handler() {
        this.applyFilters(this.appFilters);
        this.calculateTotalSize();
      },
    },
    "$route.query.q": function (value) {
      this.removeFilter("title");
      if (value !== undefined && value !== "") {
        this.searchText(value);
      }
    },
    apps: {
      handler: function (newVal) {
        if (newVal) {
          this.defaultSort();
        }
      },
    },
    isListViewApps: {
      handler: function (newVal) {
        if (!newVal) {
          this.defaultSort();
          this.sortList();
        }
        this.sortAsc = false;
      },
    },
    joinedUser: {
      handler() {
        this.storageLimit =
          this.joinedUser?.client.plan.planDetail.storageLimit;
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    const savedisListViewApps = localStorage.getItem("isListViewApps");
    if (savedisListViewApps) {
      this.isListViewApps = JSON.parse(savedisListViewApps);
    }
    this.theme = this.getTheme === "dark";
  },
  computed: {
    ...mapGetters([
      "loadingState",
      "isTrialUser",
      "applications",
      "getLabels",
      "getAppUploading",
      "joinedUser",
      "getTheme",
    ]),
    extensionOptions() {
      let types = APP_FILTERS.EXTENSION_OPTIONS;
      types.map((item) => {
        item.text = this.$t(item.text);
        return item;
      });
      return types;
    },
    appNumber() {
      return this.appFilters.length
        ? `(${this.apps?.length ?? 0} / ${
            this.applications?.length ?? 0
          } ${this.$t("app.list.counts")})`
        : `(${this.apps?.length ?? 0} ${this.$t("app.list.counts")})`;
    },
    appsToShow() {
      if (this.isListViewApps) {
        return this.sortedApps;
      }
      return this.apps.slice().sort(function (a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });
    },
    clearFilterControl() {
      return (
        this.appFilters.length > 0 &&
        this.appFilters.some((item) => item.filter !== "title")
      );
    },
    isSearched() {
      return this.$route.query.q !== undefined;
    },
    percentageGB() {
      return ((this.totalSize / this.storageLimit) * 100).toFixed(2);
    },
    totalSizeGB() {
      return Math.floor((this.totalSize / 1024) * 100) / 100;
    },
    gradientColor() {
      const color1 = "#4DC591";
      const color2 = "#2760FF";
      const stop2 = this.percentageGB;
      if (stop2 > 10 && 100 - stop2 >= 10) {
        return `linear-gradient(90deg, ${color1} 0%, ${color1} ${
          stop2 - 10
        }%, ${color2} ${stop2}%, ${color2} 100%)`;
      } else if (100 - stop2 < 10) {
        return `linear-gradient(90deg, ${color1} 0%, ${color1} ${stop2}%, ${color2})`;
      }
      return `linear-gradient(90deg, ${color1} 0%, ${color2} ${stop2}%, ${color2} 100%)`;
    },
  },
  mounted() {
    this.getAllAps();
    this.getFiltersFromStorage();
    this.defaultSort();
    this.fetchLabels();
  },
  methods: {
    ...mapActions([
      "getApplications",
      "emitUploadApp",
      "removeApplication",
      "emitMixPanelEvent",
      "emitConfirmData",
      "emitNotification",
      "addLabel",
      "updateLabel",
      "deleteLabel",
      "fetchLabels",
      "changeApplicationLabel",
      "renameApplication",
      "abortAppUpload",
    ]),
    renameApplicationById(value) {
      this.renameApplication(value)
        .then(() => {
          this.emitNotification({
            type: "success",
            text: this.$t("notification.app.success_rename"),
          });
          this.getApplications();
        })
        .catch((e) => {
          this.emitNotification({
            type: "error",
            text: e,
          });
        });
    },
    changeApplicationLabelById(value) {
      this.changeApplicationLabel(value)
        .then(() => {
          this.emitNotification({
            type: "success",
            text: this.$t("notification.label.success_add"),
          });
          this.getApplications();
        })
        .catch((e) => {
          this.emitNotification({
            type: "error",
            text: e,
          });
        });
    },
    deleteLabelById(value) {
      this.deleteLabel(value)
        .then(() => {
          this.emitNotification({
            type: "success",
            text: this.$t("notification.label.success_delete"),
          });
          this.fetchLabels();
          this.getApplications();
        })
        .catch((e) => {
          this.emitNotification({
            type: "error",
            text: e,
          });
        });
    },
    createLabel(value) {
      this.addLabel(value)
        .then(() => {
          this.emitNotification({
            type: "success",
            text: this.$t("notification.label.success_create"),
          });
          this.fetchLabels();
        })
        .catch((e) => {
          this.emitNotification({
            type: "error",
            text: e,
          });
        });
    },
    updateLabelById(value) {
      this.updateLabel(value)
        .then(() => {
          this.emitNotification({
            type: "success",
            text: this.$t("notification.label.success_update"),
          });
          this.fetchLabels();
          this.getApplications();
        })
        .catch((e) => {
          this.emitNotification({
            type: "error",
            text: e,
          });
        });
    },
    getFiltersFromStorage() {
      this.appFilters = JSON.parse(
        sessionStorage?.getItem("appFilters") ?? "[]"
      );

      this.appFilters.forEach((filter) => {
        if (filter.filter === "appExtension") {
          this.extensionFilter = filter.value;
        }
        if (filter.filter === "appLabel") {
          this.labelFilter = filter.value;
        }
      });
    },
    applyFilters(appFilters) {
      if (appFilters.length === 0) {
        this.apps = this.applications;
      } else {
        let condition = {
          appExtension: null,
          appLabel: null,
          title: null,
        };
        appFilters.forEach((filter) => {
          condition[filter.filter] = filter.value;
          if (filter.filter == "title") {
            filter.value = this.$route.query.q || "";
          }
        });
        this.apps = this.applications.filter((app) => {
          return (
            (condition.appExtension
              ? condition.appExtension.includes(
                  this.EXTENSION_ENUM[app.appType]
                )
              : true) &&
            (condition.appLabel !== null
              ? app.label !== null
                ? condition.appLabel.includes(app.label.title)
                : false
              : true) &&
            (condition.title
              ? app.title
                  .turkishToLower()
                  .includes(condition.title.turkishToLower())
              : true)
          );
        });
      }
    },
    clearFilter() {
      this.extensionFilter = [];
      this.labelFilter = [];
      this.q = "";
      //this.appFilters = [];
      this.defaultSort();
    },
    filterExtension() {
      this.appFilters.push({
        filter: "appExtension",
        value: this.extensionFilter,
        text: "Extension",
        textVal: this.extensionFilter,
      });
    },
    filterLabel() {
      this.appFilters.push({
        filter: "appLabel",
        value: this.labelFilter,
        text: "Label",
        textVal: this.labelFilter,
      });
    },
    searchText(value) {
      let filterValue = value || "";
      this.emitMixPanelEvent({
        event: "filterSearch",
        data: {
          filterSearch: filterValue,
        },
      });
      this.appFilters.push({
        filter: "title",
        value: filterValue,
        text: "Search Apps",
        textVal: filterValue,
      });
    },
    removeFilter(filter) {
      this.appFilters = this.appFilters.filter((f) => {
        return f.filter !== filter;
      });
    },
    clickFileUpload() {
      if (this.getAppUploading) {
        this.emitNotification({
          type: "error",
          text: this.$t("notification.app.upload_continues"),
        });
      } else {
        this.$refs.file.click();
      }
    },
    dropFile(event) {
      event.preventDefault();
      this.isDragEnter = false;
      if (this.getAppUploading) {
        this.emitNotification({
          type: "error",
          text: this.$t("notification.app.upload_continues"),
        });
        return;
      }
      this.selectedFile = event.dataTransfer.files[0];
      this.sizeControl =
        Math.round(this.selectedFile.size / 1024 / 1024) + this.totalSize;
      this.selectedFileExtension = this.selectedFile.name.split(".").pop();
      if (this.sizeControl > this.storageLimit) {
        this.emitConfirmData({
          header: this.$t("confirm.space_limit.header"),
          text: this.$t("confirm.space_limit.text"),
          actions: {
            confirm: this.$t("button.popup.upgrade.confirm"),
            cancel: this.$t("button.popup.upgrade.cancel"),
          },
          callback: (isConfirm) => {
            if (!isConfirm && this.loading) {
              this.abortAppUpload();
            }
            if (isConfirm) {
              this.contactSalesFormId = this.formIdList.PRO_UPGRADE;
              this.showContactSales = true;
            }
          },
        });
      } else if (this.selectedFile.name.length > 100) {
        this.emitNotification({
          type: "error",
          text: this.$t("notification.app.error_name_length"),
        });
        this.selectedFile = null;
        return;
      }
      const approvedExtensions = this.extensionOptions.map(
        (item) => item.value
      );
      if (approvedExtensions.includes(this.selectedFileExtension)) {
        this.upload();
        this.emitMixPanelEvent({
          event: "LibraryAppType",
          data: {
            app: this.selectedFile.name,
          },
        });
      } else {
        this.emitNotification({
          type: "error",
          text: this.$t("notification.app.invalid_type"),
        });
        this.removeFile();
      }
    },
    getFile(e) {
      this.emitMixPanelEvent({
        event: "LibrarySelectFile",
        data: {
          click: true,
        },
      });
      this.i++;
      if (e.target.files.length > 0) {
        this.selectedFile = e.target.files[0];
        this.sizeControl =
          Math.round(this.selectedFile.size / 1024 / 1024) + this.totalSize;
        this.selectedFileExtension = this.selectedFile.name.split(".").pop();
        if (this.selectedFile.name.length > 100) {
          this.emitNotification({
            type: "error",
            text: this.$t("notification.app.error_name_length"),
          });
          this.selectedFile = null;
          return;
        }
        const approvedExtensions = this.extensionOptions.map(
          (item) => item.value
        );
        if (!approvedExtensions.includes(this.selectedFileExtension)) {
          this.emitNotification({
            type: "error",
            text: this.$t("notification.app.invalid_type"),
          });
          this.removeFile();
          return;
        }
        this.emitMixPanelEvent({
          event: "LibraryAppType",
          data: {
            app: this.selectedFile.name,
          },
        });
        this.upload();
      }
    },
    removeItem(id) {
      this.removeApplication(id).then(() => {
        this.emitNotification({
          type: "success",
          text: this.$t("notification.app.success_deleted"),
        });
        this.getAllAps();
      });
    },
    getAllAps() {
      this.loading = true;
      this.getApplications().then((apps) => {
        this.calculateTotalSize();
        this.loading = false;
        this.emitMixPanelEvent({
          event: "LibraryAppCount",
          data: {
            LibraryAppCount: apps.length,
          },
        });
      });
    },
    removeFile() {
      this.selectedFile = null;
      this.selectedFileExtension = "";
    },
    upload() {
      if (this.sizeControl > this.storageLimit) {
        this.emitConfirmData({
          header: this.$t("confirm.space_limit.header"),
          text: this.$t("confirm.space_limit.text"),
          actions: {
            confirm: this.$t("button.popup.upgrade.confirm"),
            cancel: this.$t("button.popup.upgrade.cancel"),
          },
          callback: (isConfirm) => {
            if (!isConfirm && this.loading) {
              this.abortAppUpload();
            }
            if (isConfirm) {
              this.contactSalesFormId = this.formIdList.PRO_UPGRADE;
              this.showContactSales = true;
            }
          },
        });
      } else if (this.selectedFileExtension === "ipa") {
        this.emitConfirmData({
          header: this.$t("confirm.upload_ipa.header"),
          textTitle: this.selectedFile.name,
          text: this.$t("confirm.upload_ipa.text"),
          actions: {
            confirm: this.$t("button.popup.upload_ipa.confirm"),
            cancel: this.$t("button.popup.upload_ipa.cancel"),
          },
          callback: (isConfirm) => {
            this.emitUploadApp({
              title: this.selectedFile.name,
              file: this.selectedFile,
              isResignable: isConfirm,
            });
          },
        });
      } else {
        this.emitUploadApp({
          title: this.selectedFile.name,
          file: this.selectedFile,
          isResignable: false,
        });
      }
    },
    toggleView(isListViewApps) {
      this.isListViewApps = isListViewApps;
      this.isGridView = !isListViewApps;
      localStorage.setItem(
        "isListViewApps",
        JSON.stringify(this.isListViewApps)
      );
    },
    defaultSort() {
      this.sortedApps = this.apps
        .slice()
        .sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
    },
    sortList(title) {
      Object.keys(this.sortingTitles).forEach((key) => {
        if (key !== title) {
          this.sortingTitles[key] = "default";
        }
      });
      if (this.sortingTitles[title] === "desc") {
        this.sortAsc = false;
        this.sortingTitles[title] = "default";
        this.defaultSort();
        return;
      }
      if (this.sortingTitles[title] === "default") {
        this.sortAsc = true;
        this.sortingTitles[title] = "asc";
      } else {
        this.sortAsc = false;
        this.sortingTitles[title] = "desc";
      }
      this.sortedApps = _.orderBy(
        this.apps,
        (t) => {
          if (title === "extension") {
            return t["title"].split(".").pop();
          } else if (title === "label") {
            return t["label"]["title"];
          } else {
            return t[title];
          }
        },
        [this.sortAsc ? "asc" : "desc"]
      );
    },
    closeContactSales() {
      this.showContactSales = false;
    },
    calculateTotalSize() {
      this.totalSize = 0;
      this.applications.forEach((app) => {
        this.totalSize += app.size;
      });
    },
  },
};
</script>

<style>
@import "index.module.css";
</style>
